'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _translate = _interopRequireDefault(require("./../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var SearchResultsFilter = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchResultsFilter, _React$Component);

  function SearchResultsFilter(props) {
    var _this;

    _classCallCheck(this, SearchResultsFilter);

    _this = _possibleConstructorReturn(this, (SearchResultsFilter.__proto__ || Object.getPrototypeOf(SearchResultsFilter)).call(this, props));
    _this.state = {
      isToggleOn: false,
      toggleShowMore: false
    };
    _this.handleToggle = _this.handleToggle.bind(_assertThisInitialized(_this));
    _this.getFilterWidth = _this.getFilterWidth.bind(_assertThisInitialized(_this));
    _this.getShowMoreLabel = _this.getShowMoreLabel.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(SearchResultsFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      setTimeout(function () {
        _this2.getFilterWidth();
      }, 2000);

      if (Object.values(this.props.filters).every(function (filters) {
        return !filters.length;
      })) {
        return '';
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: 'filter-results'
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "filter-results-list ".concat(this.state.isToggleOn ? ' opened' : '')
      }, Object.keys(this.props.filters).map(function (i) {
        if (i === 'soldout' || i === 'soldOut') {
          return null;
        }

        return _this2.props.filters[i].map(function (element) {
          return /*#__PURE__*/_react.default.createElement("li", {
            className: "filter-tag",
            onClick: function onClick() {
              return _this2.props.removeFilter(element);
            },
            key: element.value
          }, t(element.value));
        });
      })), this.state.toggleShowMore && /*#__PURE__*/_react.default.createElement("div", {
        onClick: this.handleToggle,
        className: "\n                ".concat(this.state.isToggleOn ? 'show-less-link' : 'show-more-link')
      }, /*#__PURE__*/_react.default.createElement("b", null, this.getShowMoreLabel(t))));
    }
  }, {
    key: "getShowMoreLabel",
    value: function getShowMoreLabel(t) {
      if (this.state.isToggleOn) {
        return t('show-less');
      }

      return t('show-more');
    }
  }, {
    key: "getFilterWidth",
    value: function getFilterWidth() {
      var tags = document.getElementsByClassName('filter-tag');
      var container = document.getElementsByClassName('filter-results-list');
      var containerWidth,
          tagsWidth = 0;

      for (var i = 0; i < container.length; i++) {
        containerWidth = container[i].offsetWidth;
      }

      for (var _i = 0; _i < tags.length; _i++) {
        tagsWidth += tags[_i].offsetWidth; // add margin-right to width calculation as well

        var computedTagStyle = window.getComputedStyle(tags[_i]);
        var marginNumeric = parseInt(computedTagStyle['margin-right']);
        tagsWidth += marginNumeric;
      }

      if (containerWidth < tagsWidth) {
        if (this.state.toggleShowMore === false) {
          return this.setState({
            toggleShowMore: true
          });
        }
      } else if (this.state.toggleShowMore === true) {
        return this.setState({
          toggleShowMore: false
        });
      }
    }
  }, {
    key: "handleToggle",
    value: function handleToggle() {
      this.setState(function (prevState) {
        return {
          isToggleOn: !prevState.isToggleOn
        };
      });
    }
  }]);

  return SearchResultsFilter;
}(_react.default.Component);

SearchResultsFilter.propTypes = {
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  t: _propTypes.default.func,
  filters: _propTypes.default.any,
  removeFilter: _propTypes.default.func
};

var _default = (0, _translate.default)(SearchResultsFilter);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/search-results-filter/index.js
// module id = 883
// module chunks = 0